import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  url: string;
  constructor(public location_: Location) {}

  async ngOnInit() {
    window.scroll(0, 0);
    this.url = this.location_.path();
  }

  onOutletLoaded(com: any) {
    com.url = this.url;
  }
}
